import { CustomSelect } from "@/components/ui/Select";

interface LookupValue {
  id: string;
  label: string;
}

interface TaskFormCategoryFieldsProps {
  formData: {
    category_id?: string;
    priority_id?: string;
    status_id?: string;
  };
  isViewMode: boolean;
  errors: Record<string, string>;
  availableCategories: LookupValue[];
  availablePriorities: LookupValue[];
  availableStatuses: LookupValue[];
  onCategoryChange: (value: string) => void;
  onPriorityChange: (value: string) => void;
  onStatusChange: (value: string) => void;
}

export const TaskFormCategoryFields: React.FC<TaskFormCategoryFieldsProps> = ({
  formData,
  errors,
  isViewMode,
  availableCategories,
  availablePriorities,
  availableStatuses,
  onCategoryChange,
  onPriorityChange,
  onStatusChange,
}) => {
  return (
    <div className="box-border content-stretch flex flex-row gap-4 items-start justify-start p-0 relative shrink-0 w-full">
      <div className="basis-0 box-border content-stretch flex flex-col gap-1.5 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0">
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-start p-0 relative shrink-0">
          <div
            className="font-['Open_Sans:SemiBold',_sans-serif] font-semibold leading-[0] relative shrink-0 text-[#444444] text-[14px] text-left text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[1.5] whitespace-pre">
              <span>Category </span>
              <span className="text-[#e7000b]">*</span>
            </p>
          </div>
        </div>
        <CustomSelect
          value={formData.category_id || ""}
          onValueChange={onCategoryChange}
          options={[
            { value: "", label: "Select" },
            ...availableCategories.map((category) => ({
              value: category.id,
              label: category.label,
            })),
          ]}
          hasError={!!errors.category_id}
          placeholder="Select"
          disabled={isViewMode}
        />
        {errors.category_id && (
          <p className="mt-1 text-xs text-red-600">{errors.category_id}</p>
        )}
      </div>

      <div className="basis-0 box-border content-stretch flex flex-col gap-1.5 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0">
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-start p-0 relative shrink-0">
          <div
            className="font-['Open_Sans:SemiBold',_sans-serif] font-semibold leading-[0] relative shrink-0 text-[#444444] text-[14px] text-left text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[1.5] whitespace-pre">
              <span>Priority </span>
              <span className="text-[#e7000b]">*</span>
            </p>
          </div>
        </div>
        <CustomSelect
          value={formData.priority_id || ""}
          onValueChange={onPriorityChange}
          options={[
            { value: "", label: "Select" },
            ...availablePriorities.map((priority) => ({
              value: priority.id,
              label: priority.label,
            })),
          ]}
          hasError={!!errors.priority_id}
          placeholder="Select"
          disabled={isViewMode}
        />
        {errors.priority_id && (
          <p className="mt-1 text-xs text-red-600">{errors.priority_id}</p>
        )}
      </div>

      <div className="basis-0 box-border content-stretch flex flex-col gap-1.5 grow items-start justify-start min-h-px min-w-px p-0 relative shrink-0">
        <div className="box-border content-stretch flex flex-row gap-2 items-center justify-start p-0 relative shrink-0">
          <div
            className="font-['Open_Sans:SemiBold',_sans-serif] font-semibold leading-[0] relative shrink-0 text-[#444444] text-[14px] text-left text-nowrap"
            style={{ fontVariationSettings: "'wdth' 100" }}
          >
            <p className="leading-[1.5] whitespace-pre">
              <span>Status </span>
              <span className="text-[#e7000b]">*</span>
            </p>
          </div>
        </div>
        <CustomSelect
          value={formData.status_id || ""}
          onValueChange={onStatusChange}
          options={[
            { value: "", label: "Select" },
            ...availableStatuses.map((status) => ({
              value: status.id,
              label: status.label,
            })),
          ]}
          hasError={!!errors.status_id}
          placeholder="Select"
          disabled={isViewMode}
        />
        {errors.status_id && (
          <p className="mt-1 text-xs text-red-600">{errors.status_id}</p>
        )}
      </div>
    </div>
  );
};
